import * as React from 'react'
import { ChartNode, RawData } from './types'
import memoize from 'memoize-one'
import FlameGraph from './FlameGraph'
import { transformChartData } from './utils'
import { rowHeight } from './constants'

interface Props {
    data: RawData
    startNode: string
    highlightNode: string
    height: number
    width: number
    onChange?: (chartNode: ChartNode, uid: any) => void
}

// Wrapper component responsible for converting raw chart data into the format required by FlameGraph.
// Doing this conversion as a separate component has two benefits:
// 1) It simplifies FlameGraph (slightly)
// 2) It allows React's async rendering mode to more easily split up the work if this conversion is slow.
export default class FlameGraphProcessor extends React.PureComponent<Props> {
    // Convert raw chart data to the format required by the flame graph.
    // Memoize this wrapper object for performance and to avoid breaking PureComponent's sCU.
    // Attach the memoized function to the instance,
    // So that multiple instances will maintain their own memoized cache.
    __getChartdata = memoize((rawData: RawData) => transformChartData(rawData, this.props.highlightNode))

    __setFlameGraphRef = (ref: any) => {
        this.__flameGraphRef = ref
    }

    __flameGraphRef: any = null

    focusNode(uid: any) {
        if (this.__flameGraphRef) {
            this.__flameGraphRef.focusNode(uid)
        }
    }

    render() {
        const { height: minHeight, data: rawData, ...rest } = this.props

        const chartData = this.__getChartdata(rawData)

        const height = Math.max(minHeight, chartData.height * rowHeight + 10)

        return <FlameGraph ref={this.__setFlameGraphRef} data={chartData} height={height} {...rest} />
    }
}
